import OutbrainPixel from './OutbrainPixel';

export default OutbrainPixel;
